import {Injectable} from '@angular/core'

@Injectable()

export class CheckHelpers {

    exist(keys, e): boolean {
        const fails = keys.find(function (k) {
            return e.keyCode === k
        });
        return !!fails
    }
}
